import type { FaireProductEntity } from "../../entity_types/product";

export const atc_baggu_3: FaireProductEntity = {
  token: "atc_baggu_3",
  type: "product",
  name: "Small Nylon Crescent Bag - Extra Pink",
  brandName: "Baggu",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/521d92ba95d5bd1eaabf6ba4c3bbb8e25442ecd4652edbdc1c42a6c86e2abbc7.jpeg",
  priceDollars: 24,
  msrpDollars: 48,
  description: "Reusable bag made from recycled materials by Baggu.",
  tags: ["bags", "accessories", "sustainable"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
